import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mc0070',
    ecrans: ['00-2']
});
